<template>
  <div>
    <img :src="src" alt="" v-if="type == 'img'" />
    <div v-if="type == 'pdf'">
      <pdf ref="pdf" v-for="i in numPages" :key="i" :src="url" :page="i"></pdf>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import axios from "@/http/axios";
export default {
  data() {
    return {
      numPages: 0,
      url: "",
      src: "",
      type: "img",
    };
  },
  components: {
    pdf,
  },
  created() {
    let o = this.$route.query;
    sessionStorage.setItem("token", o.token);
    this.GetData();
  },
  methods: {
    GetData() {
      let promise1 = axios.postFrom2("/api/appgateway/util/findFile", {
        fileName: "bankTransactionRecordFilePath",
      });
      let promise2 = axios.postFrom("/api/appgateway/util/findFileSuffix", {
        fileName: "bankTransactionRecordFilePath",
      });
      Promise.all([promise1, promise2]).then((res) => {
        let type = res[1].data;
        if (/gif|jpg|jpeg|png|GIF|JPG|PNG/gi.test(type)) {
          this.type = "img";
          this.src = window.URL.createObjectURL(res[0]);
        } else if (type == "pdf") {
          this.type = "pdf";
          this.url = window.URL.createObjectURL(res[0]);
          this.getNumPages();
        }
      });
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {
          console.log(error);
        }
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) {
          console.log(error);
        }
      }
      return url;
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
